(function () {
  var root = document.getElementById('kh');
  if (!root) return;

  var T = { 'Wijnkoelkast': 'V', 'Onderbouw wijnkoelkast': 'O', 'Inbouw wijnkoelkast': 'I', 'WIjnkoeler inbouw': 'I', 'Ingebouwde wijnkast': 'I' };
  var R = {
    w: { zones_serve: 3, rijp_wb: 3, rijp_tv: 1, rijp_kf: 1, rijp_1zone: 1, beide_zones: 2, beide_kf: 1, stil_36: 3, stil_38: 2, wens: 2, voorraad: 1, inverter: 1, flessen_precies: 1, onder_vol: 1 },
    prio: { top: 3, hoofd: 2, tweede: 1, rest: 0 },
    merk: { 'Dunavox': 'top', 'Temptech': 'hoofd', 'Haier': 'hoofd', 'mQuvée': 'tweede', 'Pevino': 'tweede', 'Climadiff': 'tweede' },
    stil: { stil: 40, zeerstil: 38, fluister: 36 },
    tol: { flessen: 10, budget: 10, breedte: 6, onderMin: 80, onderMax: 89.5 },
    nis: { '45': [43, 46], '60': [56, 60], '88': [80, 88.5], '122': [117, 123], '140': [134, 141], '178': [170, 178.5], '190': [180, 191.5] }
  };
  var NIS_LABEL = { '45': '45 cm', '60': '60 cm', '88': '82–88 cm', '122': '122 cm', '140': '140 cm', '178': '178 cm', '190': '184–191 cm' };
  var NEUTRAAL = { plaats: '?', nis: '?', zones: '?', breedte: '?', budget: '?', flessen: null, ruimte: 'binnen', geluid: 'nvt', wensen: [] };
  var A = JSON.parse(JSON.stringify(NEUTRAAL));
  var D = [];
  var MERK = null;

  // Volgorde op basis van bezoekersdata (instap via collecties, 2026): prijs, zones en breedte worden het meest gezocht
  var Q = [
    { id: 'plaats', label: 'Waar komt de wijnkoelkast te staan?', wide: true, opts: [
      ['V', 'Vrijstaand', 'Los in de ruimte'], ['O', 'Onder het aanrecht', 'Onderbouw, lucht via de voorkant'],
      ['I', 'In een keukenkast', 'Inbouw in een nis of kolom'], ['?', 'Weet ik nog niet']] },
    { id: 'nis', show: function (a) { return a.plaats === 'I'; }, label: 'Hoe hoog is de nis?', opts: Object.keys(NIS_LABEL).map(function (k) { return [k, NIS_LABEL[k]]; }).concat([['?', 'Weet ik niet']]) },
    { id: 'zones', label: 'Hoeveel temperatuurzones wilt u?', wide: true, opts: [
      ['1', '1 zone', 'Eén soort wijn, of wijn lang bewaren'], ['2', '2 zones', 'Rood en wit tegelijk op temperatuur'],
      ['3', '3 of meer zones', 'Meerdere soorten tegelijk'], ['?', 'Weet ik niet']] },
    { id: 'breedte', show: function (a) { return a.plaats !== 'I'; }, label: 'Hoe breed mag hij zijn?', opts: [['30', 'Tot 30 cm', 'Smal'], ['45', '40 – 45 cm'], ['60', '60 cm', 'Standaard keukenmaat'], ['61', 'Breder dan 60 cm'], ['?', 'Maakt niet uit']] },
    { id: 'budget', label: 'Wat is uw budget?', opts: [['1000', 'Tot € 1.000'], ['2000', 'Tot € 2.000'], ['3500', 'Tot € 3.500'], ['6000', 'Tot € 6.000'], ['?', 'Meer dan € 6.000', 'Alle prijzen']] },
    { id: 'flessen', label: 'Hoeveel flessen wilt u kwijt?', opts: [['0-20', 'Tot 20'], ['20-50', '20 – 50'], ['50-100', '50 – 100'], ['100-200', '100 – 200'], ['200-9999', 'Meer dan 200']] },
    { id: 'ruimte', label: 'In wat voor ruimte?', wide: true, opts: [
      ['binnen', 'Verwarmde ruimte', 'Keuken, woonkamer, kantoor'], ['koud', 'Onverwarmde ruimte', 'Garage, schuur, berging, kelder']] },
    { id: 'geluid', label: 'Hoe stil moet hij zijn?', wide: true, opts: [
      ['nvt', 'Maakt niet uit'],
      ['stil', 'Stil', 'Tot ' + R.stil.stil + ' dB · prima in een keuken'],
      ['zeerstil', 'Zeer stil', 'Tot ' + R.stil.zeerstil + ' dB · voor een open keuken of woonkamer'],
      ['fluister', 'Fluisterstil', 'Tot ' + R.stil.fluister + ' dB · ook voor een slaap- of werkkamer']] },
    { id: 'wensen', multi: true, label: 'Nog wensen? (meerdere mogelijk)', opts: [['bewaren', 'Wijn jarenlang bewaren'], ['slot', 'Met slot'], ['zuinig', 'Energielabel E of beter'], ['greeploos', 'Greeploos'], ['links', 'Deur ook links te openen'], ['zwart', 'Zwart'], ['rvs', 'RVS']] }
  ];
  var TEGELS = { plaats: 1, zones: 1, ruimte: 1, geluid: 1 };
  var SVG = function (d) { return '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var SPK = 'M4 9h4l5-4v14l-5-4H4z';
  var ICO = {
    'plaats-V': SVG('M7 3h10v17H7zM7 11h10M10 6v2M2 21h20'),
    'plaats-O': SVG('M2 8h20M5 9v12h14V9M8 12h8M8 15h8M8 18h8'),
    'plaats-I': SVG('M3 2h18v20H3zM7 7h10v11H7zM9 10h6M9 13h6'),
    'plaats-?': SVG('M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z'),
    'zones-1': SVG('M6 2h12v20H6zM9 8h6M9 12h6M9 16h6'),
    'zones-2': SVG('M6 2h12v20H6zM6 12h12M9 6h6M9 17h6'),
    'zones-3': SVG('M6 2h12v20H6zM6 8.7h12M6 15.3h12M9 5.3h6M9 12h6M9 18.7h6'),
    'zones-?': SVG('M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z'),
    'ruimte-binnen': SVG('M3 11l9-7 9 7M5 10v10h14V10M10 20v-5h4v5'),
    'ruimte-koud': SVG('M12 2v20M4.9 7l14.2 10M4.9 17L19.1 7M9 3.5l3 2 3-2M9 20.5l3-2 3 2'),
    'geluid-nvt': SVG(SPK + 'M16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12'),
    'geluid-stil': SVG(SPK + 'M16 9a4 4 0 0 1 0 6'),
    'geluid-zeerstil': SVG(SPK + 'M16 10.5a2 2 0 0 1 0 3'),
    'geluid-fluister': SVG(SPK + 'M17 10l4 4M21 10l-4 4')
  };
  var VINK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
  var QBY = {}; Q.forEach(function (q) { QBY[q.id] = q; });
  var WENS = {
    bewaren: [function (p) { return p.wb === 1; }, 'Wijnbewaarkast, gemaakt om lang te bewaren', 'Geen wijnbewaarkast'],
    slot: [function (p) { return p.sl === 1; }, 'Met slot', 'Geen slot'],
    zuinig: [function (p) { return p.el && p.el <= 'E'; }, function (p) { return 'Energielabel ' + p.el; }, function (p) { return 'Energielabel ' + (p.el || 'onbekend'); }],
    greeploos: [function (p) { return p.gl === 1; }, 'Greeploos', 'Niet greeploos'],
    links: [function (p) { return p.sa === 1; }, 'Deur kan links of rechts', 'Draairichting vast'],
    zwart: [function (p) { return p.c.indexOf('Zwart') > -1; }, 'Zwart', 'Niet zwart'],
    rvs: [function (p) { return p.c.indexOf('RVS') > -1; }, 'RVS', 'Geen RVS']
  };

  function num(s) {
    if (s == null) return null;
    if (typeof s === 'number') return s;
    if (Array.isArray(s)) return s.length ? num(s[0]) : null;
    if (typeof s === 'object') return s.value != null ? num(s.value) : null;
    var m = String(s).replace(',', '.').match(/\d+(\.\d+)?/);
    return m ? +m[0] : null;
  }
  function yn(s) { return s === true || s === 'Ja' ? 1 : s === false || s === 'Nee' ? 0 : null; }
  function derive(r) {
    var mt = r.mt;
    if (typeof mt === 'string') { try { mt = JSON.parse(mt); } catch (e) { mt = [mt]; } }
    if (!Array.isArray(mt)) mt = [];
    var k = [];
    if (mt.indexOf('Vrijstaand') > -1) k.push('V');
    if (mt.indexOf('Onderbouw') > -1) k.push('O');
    if (mt.indexOf('Inbouw') > -1) k.push('I');
    if (!k.length && T[r.ty]) k = [T[r.ty]];
    var kt = r.kt ? String(r.kt) : null;
    var c = [];
    (r.c || []).forEach(function (l) {
      l = String(l || '').toLowerCase();
      if (l.indexOf('zwart') > -1 || l === 'black') c.push('Zwart');
      if (l.indexOf('rvs') > -1 || l.indexOf('roestvrij') > -1 || l.indexOf('stainless') > -1 || l.indexOf('staal') > -1) c.push('RVS');
    });
    return {
      id: r.id, t: r.t, v: r.v, u: r.u, i: r.i, p: num(r.p), s: r.s || 0, k: k, wb: mt.indexOf('Wijnbewaarkast') > -1 ? 1 : 0,
      f: num(r.f), z: r.z == null ? null : (/multi/i.test(String(r.z)) ? 3 : num(r.z)),
      b: num(r.b), h: num(r.h), d: num(r.d), db: num(r.db), g: yn(r.g),
      kt: kt ? (/inverter/i.test(kt) ? 'inv' : /peltier|thermo/i.test(kt) ? 'pel' : 'cmp') : null,
      el: (r.el ? String(r.el) : '').trim().toUpperCase()[0] || null,
      sl: yn(r.sl), kf: yn(r.kf), tv: yn(r.tv), sa: yn(r.sa), gl: yn(r.gl), c: c,
      cp: num(r.cp), elu: r.elu || null, zr: r.z == null ? null : (Array.isArray(r.z) ? r.z.join(', ') : String(r.z))
    };
  }

  var eur = function (n) { return n == null ? 'Prijs op aanvraag' : new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n); };
  var fmt = function (n) { return n == null ? '?' : String(n).replace('.', ','); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var range = function (s) { return s.split('-').map(Number); };
  var optLabel = function (id, v) { var o = QBY[id].opts.filter(function (x) { return x[0] === v; })[0]; return o ? o[1].toLowerCase() : v; };

  function filters(a) {
    var f = [];
    if (MERK) f.push({ ok: function (p) { return p.v === MERK; } });
    if (a.plaats !== '?') f.push({ n: 'plaatsing', ok: function (p) { return p.k.indexOf(a.plaats) > -1; } });
    if (a.plaats === 'I' && a.nis !== '?') { var lo = R.nis[a.nis][0], hi = R.nis[a.nis][1]; f.push({ n: 'nishoogte ' + NIS_LABEL[a.nis], need: 'h', ok: function (p) { return p.h >= lo && p.h <= hi; } }); }
    if (a.zones !== '?') { var zn = +a.zones; f.push({ n: 'aantal zones', need: 'z', ok: function (p) { return zn >= 3 ? p.z >= 3 : p.z === zn; } }); }
    if (a.plaats !== 'I' && a.breedte !== '?') { var BR = { '30': [0, 31], '45': [37, 46], '60': [54, 60.5], '61': [60.5, 999] }[a.breedte]; f.push({ n: 'breedte', need: 'b', ok: function (p) { return p.b > BR[0] - (a.breedte === '61' ? 0 : 0.01) && p.b <= BR[1]; } }); }
    if (a.flessen) { var fr = range(a.flessen), t = R.tol.flessen / 100; f.push({ n: 'aantal flessen', need: 'f', ok: function (p) { return p.f >= fr[0] * (1 - t) && p.f <= fr[1] * (1 + t); } }); }
    if (a.geluid !== 'nvt') { var lim = R.stil[a.geluid]; f.push({ n: 'geluid tot ' + lim + ' dB', need: 'db', ok: function (p) { return p.db <= lim; } }); }
    if (a.ruimte === 'koud') f.push({ n: 'onverwarmde ruimte', need: 'g', ok: function (p) { return p.g === 1; } });
    if (a.budget !== '?') { var bh = +a.budget, bt = R.tol.budget / 100; f.push({ n: 'budget ' + optLabel('budget', a.budget), need: 'p', ok: function (p) { return p.p <= bh * (1 + bt); } }); }
    return f;
  }
  function passes(fs, p) { for (var i = 0; i < fs.length; i++) { var f = fs[i]; if (f.need && p[f.need] == null) return false; if (!f.ok(p)) return false; } return true; }

  function score(p, a) {
    var w = R.w, r = [];
    var add = function (pts, txt) { r.push([pts, txt]); };
    if (a.geluid !== 'nvt' && p.db != null) {
      if (p.db <= 36) add(w.stil_36, 'Heel stil: ' + p.db + ' dB');
      else if (p.db <= 38) add(w.stil_38, 'Stil: ' + p.db + ' dB');
    }
    if (a.plaats === 'O' && p.h >= R.tol.onderMin && p.h <= R.tol.onderMax) add(w.onder_vol, 'Vult de ruimte onder het aanrecht (' + fmt(p.h) + ' cm hoog)');
    a.wensen.forEach(function (k) {
      var x = WENS[k];
      if (x[0](p)) add(w.wens, typeof x[1] === 'function' ? x[1](p) : x[1]);
    });
    if (a.flessen) { var fr = range(a.flessen); if (p.f >= fr[0] && p.f <= fr[1]) add(w.flessen_precies, p.f + ' flessen, past bij uw keuze'); }
    if (p.kt === 'inv') add(w.inverter, 'Invertercompressor: zuiniger en stiller');
    if (p.s > 0) add(w.voorraad, 'Op voorraad');
    var mb = R.prio[R.merk[p.v] || 'rest'] || 0;
    return { tot: r.reduce(function (s, x) { return s + x[0]; }, 0) + mb, r: r };
  }

  function run(a) {
    var fs = filters(a), left = D.filter(function (p) { return passes(fs, p); });
    var blocker = null;
    if (!left.length) {
      var cur = D.slice();
      for (var i = 0; i < fs.length; i++) { cur = cur.filter(function (p) { return passes([fs[i]], p); }); if (!cur.length) { blocker = fs[i].n; break; } }
    }
    var out = left.map(function (p) { return { p: p, sc: score(p, a) }; }).sort(function (x, y) {
      return y.sc.tot - x.sc.tot || (y.p.s > 0) - (x.p.s > 0) || (x.p.p == null ? 1e9 : x.p.p) - (y.p.p == null ? 1e9 : y.p.p);
    });
    return { out: out, blocker: blocker };
  }
  function count(a) { var fs = filters(a); var n = 0; for (var i = 0; i < D.length; i++) if (passes(fs, D[i])) n++; return n; }

  function renderQs() {
    var el = document.getElementById('khQs'), n = 0;
    var zicht = Q.filter(function (q) { return !q.show || q.show(A); });
    var tel = zicht.filter(function (q) { return !q.multi; }), klaar = tel.filter(function (q) { return A[q.id] !== NEUTRAAL[q.id]; }).length;
    var pct = Math.round(100 * klaar / tel.length);
    el.innerHTML = '<div class="kh-prog"><div class="kh-prog-t">' + (klaar === 0 ? 'Begin met de eerste vraag' : klaar === tel.length ? 'Alle vragen beantwoord' : klaar + ' van ' + tel.length + ' vragen beantwoord') + '</div><div class="kh-prog-bar"><i style="width:' + pct + '%"></i></div></div>' + zicht.map(function (q, i) {
      n++;
      var basis = JSON.parse(JSON.stringify(NEUTRAAL));
      zicht.slice(0, i).forEach(function (v) { basis[v.id] = A[v.id]; });
      var done = q.multi ? A.wensen.length > 0 : A[q.id] !== NEUTRAAL[q.id];
      return '<div class="kh-q' + (done ? ' done' : '') + '"><h3><span class="n">' + (done ? VINK : n) + '</span>' + q.label + '</h3><div class="kh-opts' + (TEGELS[q.id] ? ' tiles' : q.wide ? ' wide' : '') + '">' + q.opts.map(function (o) {
        var v = o[0], on = q.multi ? A.wensen.indexOf(v) > -1 : A[q.id] === v;
        var probe = {}; for (var k in basis) probe[k] = basis[k]; probe[q.id] = v;
        var leeg = D.length && !q.multi && !on && count(probe) === 0;
        return '<button type="button" class="kh-opt" id="kh-' + q.id + '-' + v.replace(/\W/g, '_') + '" data-q="' + q.id + '" data-v="' + v + '" aria-pressed="' + on + '"' + (leeg ? ' disabled' : '') + '>' + (TEGELS[q.id] && ICO[q.id + '-' + v] ? '<span class="ico">' + ICO[q.id + '-' + v] + '</span>' : '') + '<span class="l">' + o[1] + '</span>' + (o[2] ? '<small>' + o[2] + '</small>' : '') + (leeg && !o[2] ? '<small>Geen modellen</small>' : '') + '</button>';
      }).join('') + '</div></div>';
    }).join('');
  }

  function bezig() { for (var k in NEUTRAAL) { if (k === 'wensen') { if (A.wensen.length) return true; } else if (A[k] !== NEUTRAAL[k]) return true; } return false; }

  var MEER = 12;
  var money = function (n) { return n == null ? 'Prijs op aanvraag' : new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(n); };
  // Zelfde specificatieregels als op de producttegels van de collectiepagina (snippets/product-grid-specs.liquid)
  var specs = function (p) {
    var r = [];
    if (p.f != null) r.push('<li><span>Aantal flessen</span><span>' + fmt(p.f) + '</span></li>');
    if (p.zr) r.push('<li><span>Aantal zones</span><span>' + esc(p.zr) + '</span></li>');
    if (p.h && p.b && p.d) r.push('<li class="spec--afm"><span>Afmetingen<span class="spec-hbd"> (h×b×d)</span></span><span>' + fmt(p.h) + ' × ' + fmt(p.b) + ' × ' + fmt(p.d) + ' cm</span></li>');
    if (p.db != null) r.push('<li><span>Geluidsniveau</span><span>' + fmt(p.db) + ' dB</span></li>');
    if (p.el) r.push('<li><span>Energielabel</span><span>' + (p.elu ? '<a href="' + esc(p.elu) + '" target="_blank" rel="noopener" title="Bekijk het energielabel">' + p.el + '</a>' : p.el) + '</span></li>');
    return r.length ? '<ul class="productitem--specs">' + r.join('') + '</ul>' : '';
  };
  var why = function (r) {
    var plus = r.filter(function (x) { return x[0] > 0; }).slice(0, 4), min = r.filter(function (x) { return x[0] < 0; });
    if (!plus.length && !min.length) return '';
    return '<ul class="kh-why">' + plus.map(function (x) { return '<li class="plus"><span>' + esc(x[1]) + '</span></li>'; }).join('') + min.map(function (x) { return '<li class="min"><span>' + esc(x[1]) + '</span></li>'; }).join('') + '</ul>';
  };
  var alleenVrij = function (p) { return A.plaats !== 'V' && p.k.length === 1 && p.k[0] === 'V'; };
  var VRIJ = 'Uitsluitend voor vrijstaand gebruik';
  var kort = function (p) {
    var s = [];
    if (p.f != null) s.push(fmt(p.f) + ' flessen');
    if (p.z != null) s.push(p.z + (p.z === 1 ? ' zone' : ' zones'));
    if (p.db != null) s.push(fmt(p.db) + ' dB');
    s.push(p.s > 0 ? 'op voorraad' : 'levertijd op aanvraag');
    return s.join(' · ');
  };
  // Producttegel in dezelfde opbouw als de collectiepagina: foto, prijs, titel, voorraad, specificaties
  function card(x, i, top) {
    var p = x.p, sale = p.cp && p.p && p.cp > p.p;
    return '<div class="kh-item' + (top && i === 0 ? ' first' : '') + '"><div class="productitem">' +
      '<a class="kh-img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="" width="360" height="360"' + (top ? '' : ' loading="lazy"') + '>' : '') +
        (top ? '<span class="kh-rank">' + (i === 0 ? 'Beste keuze' : 'Keuze ' + (i + 1)) + '</span>' : '') +
        (sale ? '<span class="productitem__badge productitem__badge--sale">Bespaar ' + money(p.cp - p.p) + '</span>' : '') +
      '</a>' +
      '<div class="productitem--info">' +
        '<div class="price productitem__price">' +
          (sale ? '<div class="price__compare-at visible"><span class="money price__compare-at--single">' + money(p.cp) + '</span></div>' : '') +
          '<div class="price__current price__current--emphasize' + (sale ? ' price__current--on-sale' : '') + '"><span class="money">' + money(p.p) + '</span></div>' +
        '</div>' +
        '<h3 class="productitem--title"><a href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
        '<span class="kh-stock ' + (p.s > 0 ? 'y">Op voorraad' : 'n">Levertijd op aanvraag') + '</span>' +
        (alleenVrij(p) ? '<span class="kh-vrij">' + VRIJ + '</span>' : '') +
        specs(p) +
        (top ? why(x.sc.r) + '<a class="kh-btn" href="' + esc(p.u) + '">Bekijk deze wijnkoelkast</a>' : '') +
      '</div></div></div>';
  }

  function render() {
    renderQs();
    var res = run(A), out = res.out, el = document.getElementById('khResults');
    var gestart = bezig();
    document.getElementById('khReset').hidden = !gestart;
    document.getElementById('khSub').textContent = out.length ? out.length + (out.length === 1 ? ' model past' : ' modellen passen') + (gestart ? ' bij uw antwoorden' : '') : '';
    document.getElementById('khTitle').textContent = !out.length ? 'Geen passend model' : !gestart ? 'Onze aanraders' : out.length >= 3 ? 'Uw top 3' : 'Dit past bij u';
    var jump = document.getElementById('khJump');
    jump.hidden = !gestart;
    jump.textContent = out.length ? 'Bekijk ' + out.length + (out.length === 1 ? ' model' : ' modellen') + ' ↓' : 'Geen passend model ↓';
    if (!out.length) {
      var tip = res.blocker ? '<p>Bij de vraag over ' + esc(res.blocker) + ' blijft er niets over. Kies daar een ruimere optie.</p>' : '<p>Kies bij een van de vragen een ruimere optie.</p>';
      if (A.budget !== '?') {
        var ruimA = JSON.parse(JSON.stringify(A)); ruimA.budget = '?';
        var ruim = run(ruimA).out;
        if (ruim.length) {
          var min = Math.min.apply(null, ruim.map(function (x) { return x.p.p == null ? 1e9 : x.p.p; }));
          tip = '<p>Zonder budgetgrens ' + (ruim.length === 1 ? 'past er 1 model' : 'passen er ' + ruim.length + ' modellen') + ', vanaf ' + eur(min) + '.</p><button type="button" class="kh-btn" id="khRuim">Toon zonder budgetgrens</button>';
        }
      }
      el.innerHTML = '<div class="kh-empty"><p><b>Geen enkel model past bij al uw antwoorden.</b></p>' + tip + '<p>Of <a href="/pages/contact">vraag ons om advies</a>.</p></div>';
      return;
    }
    el.classList.remove('kh-in'); void el.offsetWidth; el.classList.add('kh-in');
    var rest = out.slice(3, 3 + toon);
    el.innerHTML = '<div class="kh-top">' + out.slice(0, 3).map(function (x, i) { return card(x, i, true); }).join('') + '</div>' +
      (rest.length ? '<div class="kh-more"><h3>Ook passend</h3><ul class="kh-list">' + rest.map(function (x) {
        var p = x.p;
        return '<li><a href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="72" height="72">' : '<span class="ph"></span>') +
          '<span><span class="t">' + esc(p.t) + '</span><span class="s">' + kort(p) + '</span>' + (alleenVrij(p) ? '<span class="kh-vrij">' + VRIJ + '</span>' : '') + '</span><span class="p">' + eur(p.p) + '</span></a></li>';
      }).join('') + '</ul>' +
        (out.length > 3 + toon ? '<button type="button" class="kh-more-btn" id="khMeer">Toon meer (' + (out.length - 3 - toon) + ')</button>' : '') + '</div>' : '');
  }

  function renderChip() {
    var chip = document.getElementById('khChip');
    if (!MERK) { chip.hidden = true; return; }
    chip.hidden = false;
    chip.innerHTML = '<span>U ziet alleen <b>' + esc(MERK) + '</b>-modellen</span><button type="button" id="khChipX">Alle merken vergelijken</button>';
  }

  var toon = MEER;
  root.addEventListener('click', function (e) {
    if (e.target.closest('#khChipX')) { MERK = null; toon = MEER; renderChip(); render(); return; }
    if (e.target.id === 'khRuim') { A.budget = '?'; toon = MEER; render(); return; }
    if (e.target.id === 'khMeer') { toon += MEER; render(); return; }
    if (e.target.id === 'khReset') { A = JSON.parse(JSON.stringify(NEUTRAAL)); toon = MEER; render(); return; }
    var b = e.target.closest('.kh-opt'); if (!b) return;
    var q = b.dataset.q, v = b.dataset.v;
    if (q === 'wensen') A.wensen = A.wensen.indexOf(v) > -1 ? A.wensen.filter(function (x) { return x !== v; }) : A.wensen.concat([v]);
    else A[q] = A[q] === v && q !== 'ruimte' && q !== 'geluid' ? NEUTRAAL[q] : v;
    toon = MEER;
    render();
    var again = document.getElementById(b.id); if (again) again.focus();
  });
  if ('IntersectionObserver' in window) {
    var jumpEl = document.getElementById('khJump');
    new IntersectionObserver(function (en) { jumpEl.style.visibility = en[0].isIntersecting ? 'hidden' : 'visible'; }, { rootMargin: '0px 0px -40% 0px' }).observe(document.getElementById('khRes'));
  }

  var params = new URLSearchParams(location.search);
  if (/^[VOI]$/.test(params.get('plaats') || '')) A.plaats = params.get('plaats');
  var merkParam = params.get('merk');

  function grab(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var s = doc.querySelector('script[data-kh-data]');
    if (!s) return { pages: 1, list: [] };
    var list = []; try { list = JSON.parse(s.textContent); } catch (e) {}
    return { pages: +s.getAttribute('data-pages') || 1, list: list.filter(Boolean) };
  }
  function load() {
    var KEY = 'kh-data-v2';
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.at < 30 * 60 * 1000) return Promise.resolve(c.list); } catch (e) {}
    var url = function (n) { return root.dataset.source + '?section_id=keuzehulp-data&page=' + n; };
    return fetch(url(1)).then(function (r) { return r.text(); }).then(function (h) {
      var first = grab(h), rest = [];
      for (var n = 2; n <= first.pages; n++) rest.push(fetch(url(n)).then(function (r) { return r.text(); }).then(function (t) { return grab(t).list; }));
      return Promise.all(rest).then(function (more) {
        var all = first.list.concat.apply(first.list, more);
        try { sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), list: all })); } catch (e) {}
        return all;
      });
    });
  }

  renderQs();
  load().then(function (list) {
    var seen = {};
    D = list.filter(function (r) { if (seen[r.id]) return false; seen[r.id] = 1; return true; }).map(derive).filter(function (p) { return p.u; });
    if (merkParam && D.some(function (p) { return p.v === merkParam; })) MERK = merkParam;
    renderChip(); render();
  }).catch(function () {
    document.getElementById('khTitle').textContent = 'Laden lukt niet';
    document.getElementById('khResults').innerHTML = '<p>De keuzehulp kon niet laden. Bekijk <a href="' + root.dataset.source + '">alle wijnkoelkasten</a> of <a href="/pages/contact">vraag ons om advies</a>.</p>';
  });
})();
